export default class LoginModel {
  title: string;
  registrationLabel: string;
  submitButton: string;
  loginPageLink: string;
  registrationLink: string;
}